<template>
  <div v-html="displayedTemplateHtml"></div>
</template>

<script>
import helper from 'util/helpers'
import KakaoInstantMessageUtil from '../../ticket/util/kakaoInstantMessageUtil'

export default {
  name: 'instant_message_template',
  props: {
    plusFriendId: String,
    originalTemplate: Object,
    templateVariables: Array,
    readOnly: Boolean,
    instantMessageType: String
  },
  data () {
    return {
      displayedTemplateHtml: '',
      sendMessage: '',
      shortURL: ''
    }
  },
  watch: {
    originalTemplate (newVal) {
      this.initialize()
    },
    templateVariables (newArr) {
      this.initialize()
    }
  },
  mounted () {
    if (KakaoInstantMessageUtil.isInstantMessageTypeTicket(this.instantMessageType)) {
      this.getShortURL()
    }
  },
  methods: {
    initialize () {
      if (helper.isObjectValid(this.originalTemplate) && this.originalTemplate.templateContent.length > 0) {
        this.displayedTemplateHtml = ''
        this.renewTemplateProcess()
      }
    },
    renewTemplateProcess () {
      this.makeTemplateHtml()
        .then(() => this.kakaoInputEventAdd())
    },
    getShortURL () {
      if (!this.$route.query.displayId) {
        return
      }
      const displayId = this.$route.query.displayId.replace('#', '')
      this.axios.get(`/gateway/ticket/shortenURL?displayId=${encodeURI(displayId)}`, {}).then(result => {
        if (result.data.code !== 0) throw result.data.message
        this.clearShortURL()
        this.shortURL = result.data.data
      }, () => this.$alertMsg(this.$const.SYS_ERR))
        .catch(errorMsg => this.$alertMsg(errorMsg))
    },
    clearShortURL () {
      this.shortURL = ''
    },
    makeTemplateHtml () {
      let consultURLIndex = null
      let slicedURL = `${this.shortURL.slice(0, this.shortURL.length - 4)}...`
      return new Promise(resolve => {
        let tempPage = `${this.originalTemplate.templateContent}`
        this.templateVariables.forEach((obj, idx) => {
          const regExp = new RegExp(`<%${obj.name}%>`, 'g')
          const bodyStyle = getComputedStyle(document.querySelector('div.template_body'))
          const fontSize = bodyStyle.fontSize.replace(/[^\d]+/g, '')
          const variableInputTag = `<span class="hoverInp"><input class="kakao-variable-${idx} kakao-variable-input" \
                                           placeholder="${obj.name}" \
                                           ${this.setDisabled(obj)} \
                                            style="width: ${this.calculateInoutTagLength(obj.name, fontSize)}; min-width: ${this.calculateInoutTagLength(obj.name, fontSize)};" \
                                           value='${this.setValueByObject(obj, slicedURL)}'/></span>`
          tempPage = tempPage.replace(regExp, variableInputTag)
          if (KakaoInstantMessageUtil.isNameConsultUrl(obj.name)) {
            consultURLIndex = idx
          }
        })
        tempPage = '<div class="templateText">' + tempPage.replace(/\n/g, '<br/>') + '</div>'

        if (helper.isStringValid(this.originalTemplate.buttonJson)) {
          tempPage += this.addKakaoInstantButton()
        }
        this.displayedTemplateHtml = tempPage
        if (consultURLIndex && KakaoInstantMessageUtil.isInstantMessageTypeTicket(this.instantMessageType)) {
          this.templateVariables[consultURLIndex].value = slicedURL
        }
        resolve()
      })
    },
    setValueByObject (obj, slicedURL) {
      return obj.value !== '' ? obj.value : (KakaoInstantMessageUtil.isNameConsultUrl(obj.name) && this.shortURL && KakaoInstantMessageUtil.isInstantMessageTypeTicket(this.instantMessageType) ? slicedURL : '')
    },
    setDisabled (obj) {
      return KakaoInstantMessageUtil.isNameConsultUrl(obj.name) && KakaoInstantMessageUtil.isInstantMessageTypeTicket(this.instantMessageType) ? 'disabled' : ''
    },
    addKakaoInstantButton () {
      const buttonJson = JSON.parse(this.originalTemplate.buttonJson)
      const buttonKeys = Object.keys(buttonJson)
      const buttons = []

      buttonKeys.forEach(key => {
        const buttonIndex = /\d{1}/.exec(key)[0] - 1
        const buttonVariableKey = key.replace(/\d{1}/, '')

        if (!helper.isObjectValid(buttons[buttonIndex])) {
          buttons[buttonIndex] = {}
        }

        buttons[buttonIndex][buttonVariableKey] = buttonJson[key]
      })

      let buttonLayout = '<div class="templateText">'
      buttons.forEach(button => {
        buttonLayout += `<div class="kakakoBtn" >${button.type * 1 > 1 ? `<a href=${button.url_1} target="_blank">${button.name}</a>` : button.name}</div>`
      })
      buttonLayout += '</div>'
      return buttonLayout
    },
    kakaoInputEventAdd () {
      this.templateVariables.forEach((obj, idx) => {
        document.querySelectorAll(`input.kakao-variable-${idx}.kakao-variable-input`).forEach(inputTag => {
          inputTag.addEventListener('focusout', this.kakaoInputHandler)
          inputTag.addEventListener('keydown', this.kakaoResizer)
        })
      })
    },
    kakaoInputHandler (_event) {
      const classIdentifier = _event.target.className.replace(/\s/g, '.')
      document.querySelectorAll(`input.${classIdentifier}`).forEach(target => {
        target.value = _event.target.value
        const variableIndex = classIdentifier.replace(/[^\d]+/g, '') * 1
        this.templateVariables[variableIndex].value = this.checkVariableIsUrl(_event.target.value) ? `${_event.target.value} ` : _event.target.value
      })
    },
    checkVariableIsUrl (variable) {
      return /((http(s)?:\/\/)?([\w]+\.)+[\w-]+(\/[\w-./?%&=]*)?)/.test(variable)
    },
    kakaoResizer (_event) {
      const classIdentifier = _event.target.className.replace(/\s/g, '.')
      const inputValue = _event.target.value
      const bodyStyle = getComputedStyle(document.querySelector('div.template_body'))
      const fontSize = bodyStyle.fontSize.replace(/[^\d]+/g, '')
      document.querySelectorAll(`input.${classIdentifier}`).forEach(target => {
        target.style.width = this.calculateInoutTagLength(inputValue, fontSize)
        target.value = inputValue
      })
    },
    calculateInoutTagLength (inputValue, fontSize) {
      const inputLength = inputValue.length
      return Math.trunc(inputLength * fontSize * (this.checkVariableContainHangul(inputValue) ? 1.2 : 0.5) + 4) + 'px'
    },
    checkVariableContainHangul (value) {
      return /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g.test(value)
    },
    getRealLink () {
      return this.shortURL
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/menus/message/fragments/instant_message_template.vue